import * as actionTypes from '../actions/actionTypes';

const initialState = {expenses: []}

const expensesReducer = (state=initialState, action) => {
    switch(action.type) {
        case actionTypes.FETCH_EXPENSES: {
            return {
                ...state,
                expenses: action.data
            }
        }
        case actionTypes.CREATE_EXPENSE: {
            return {
                ...state,
                expenses: [...state.expenses, action.data]
            }
        }
        case actionTypes.UPDATE_EXPENSE: {
            console.log(action.data)
            return {
                ...state,
                expenses: state.expenses.map((item) => {
                    if(item.id === action.data.id) {
                        return {...action.data}
                    }
                    return item
                })
            }
        }
        case actionTypes.DELETE_EXPENSE: {
            console.log(action.id, state.expenses.filter(expense => expense.id !== action.id))
            return {
                ...state,
                expenses: state.expenses.filter(expense => expense.id !== action.id)
            }
        }
        case actionTypes.CLEAR_SALE: {
            return initialState;
        }
        default: {
            return state;
        }
    }
}

export default expensesReducer;